import { makeStyles } from '@material-ui/core/styles';

const avatarWidth = 140;

export default makeStyles(theme => ({
  root: {
    width: avatarWidth + 40,
    margin: 10,
  },
  avatar: {
    height: avatarWidth,
    width: avatarWidth,
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 5,
  },
  contentRoot: {
    padding: 3,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  uploadTitle: {
    color: theme.palette.text.secondary,
  },
}));
